import React from "react"
import BackgroundImage from "gatsby-background-image"
import styled from "styled-components"

// Common Components
import {
  BodyCopy,
  StyledHeading,
  AutoPlayCarousel,
  CallToAction,
} from "../../common"
// Slide

const StyledBannerFallback = styled.div`
  background-image: url(${(props) => props.src});
  background-size: cover;
  width: 100%;
  height: 300px;
  display: block;
  @media ${(props) => props.theme.breakpoints.medium} {
    position: absolute !important;
    height: 100%;
    top: 0;
    left: 0;
  }
`

const BannerImage = ({ mobile, desktop }) => {
  const sources = desktop.localFile
    ? [
        {
          ...desktop.localFile.childImageSharp.gatsbyImageData,
          media: `(min-width: 768px)`,
        },
      ]
    : null
  return (
    <>
      {sources ? (
        <BackgroundImage fluid={sources} />
      ) : (
        <StyledBannerFallback src={desktop.url} className="styled-bg" />
      )}
    </>
  )
}
const StyledBannerSlide = styled.div`
  width: 100%;
  flex: 0 0 auto;
  height: 100vh;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 0 ${(props) => props.theme.padding.hMobile};
  background: ${(props) => (props.background ? props.background : "#fff")};
  color: ${(props) => (props.textColor ? props.textColor : "#fff")};
  > ${BodyCopy} {
    position: relative;
    z-index: 10;
    color: inherit;
    h1 {
      color: inherit;
      max-width: 15em;
      margin-left: 0;
    }
    p {
      margin-left: 0;
      font-size: 1rem;
      max-width: 30em;
      font-weight: 700;
    }
  }

  > .gatsby-image-wrapper {
    width: 100% !important;
    height: 100%;
    display: block;
    position: absolute !important;
    left: 0;
    top: 0;
    z-index: 0;
  }
  @media ${(props) => props.theme.breakpoints.medium} {
    padding: 0 ${(props) => props.theme.padding.hDesk};
  }
`

const BannerSlide = ({
  banner_image,
  mobile_banner_image,
  banner_title,
  banner_text,
  link_type,
  link_text,
  link_target,
  page_link,
  background_color,
  text_color,
}) => {
  const isImage = banner_image?.localFile || banner_image?.url
  return (
    <StyledBannerSlide
      background={background_color}
      textColor={text_color}
      isImage={isImage}
    >
      {isImage && (
        <BannerImage mobile={mobile_banner_image} desktop={banner_image} />
      )}
      <BodyCopy>
        <StyledHeading size="h1">{banner_title?.text}</StyledHeading>
        <div dangerouslySetInnerHTML={{ __html: banner_text?.html }} />
        <CallToAction
          type={link_type}
          text={link_text}
          target={link_target}
          page={page_link}
        />
      </BodyCopy>
    </StyledBannerSlide>
  )
}
// Slider
export const BannerSlider = ({ items }) => {
  return (
    <AutoPlayCarousel>
      {items.map((item, index) => (
        <BannerSlide key={`bannerSlide-${index}`} {...item} />
      ))}
    </AutoPlayCarousel>
  )
}
